import {createSlice} from "@reduxjs/toolkit";

const setProductSlice = createSlice({
    name: 'ProductSlice',
    initialState: {
        id: null,
        name: null,
        price: null,
        img: null,
        factory: "Фабрика \"Viluta\", г. Днепр",
        isAvailable: true,
        categoryTitle: null,
        reviews: [{
            id: 1,
            name: 'Андрей',
            text: 'Повседневная практика показывает, что рамки и место обучения кадров обеспечивает широкому кругу (специалистов) участие' +
                ' в формировании направлений прогрессивного развития. Товарищи! новая модель организационной деятельности позволяет оценить' +
                ' значение соответствующий условий активизации. Не следует, однако забывать,' +
                ' что новая модель организационной деятельности влечет за собой процесс внедрения и модернизации систем массового участия.'
        }, {
            id: 2,
            name: 'Олег',
            text: 'Не следует, однако забывать, что постоянное информационно-пропагандистское обеспечение нашей деятельности' +
                ' обеспечивает широкому кругу (специалистов) участие в формировании модели развития. '
        },
            {
                id: 3,
                name: 'Виталий',
                text: 'Не следует, однако забывать, что реализация намеченных плановых заданий в значительной степени обуславливает' +
                    ' создание модели развития. Значимость этих проблем настолько очевидна, что постоянное информационно-пропагандистское обеспечение' +
                    ' нашей деятельности влечет за собой процесс внедрения и модернизации систем массового участия.' +
                    ' Товарищи! постоянное информационно-пропагандистское обеспечение нашей деятельности требуют от нас анализа соответствующий' +
                    ' условий активизации.'
            }]

    },
    reducers: {
        setProduct(state, action) {
            state.id = action.payload.id;
            state.name = action.payload.name;
            state.price = action.payload.price;
            state.img = action.payload.img;
            state.categoryTitle = action.payload.categoryTitle;
        },
        addReview(state, action) {
            state.reviews.push({id:state.reviews.length+1, ...action.payload});
        }
    }
})

export const {setProduct, addReview} = setProductSlice.actions;

export default setProductSlice.reducer;